"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var VideoPlayerIds_1 = __importDefault(require("./VideoPlayerIds"));
var VideoPreviewController = /** @class */ (function () {
    function VideoPreviewController(_a) {
        var _this = this;
        var video = _a.video, progressBar = _a.progressBar, progressBarCustomIntro = _a.progressBarCustomIntro, buttonPlay = _a.buttonPlay, buttonFullscreen = _a.buttonFullscreen, buttonVolume = _a.buttonVolume, buttonNextVideo = _a.buttonNextVideo, inputVolumeRange = _a.inputVolumeRange, videoContainer = _a.videoContainer;
        this.playbackRateValues = [1, 1.2, 1.5, 1.7, 2];
        // getActualProgress = () => {
        //   const { video } = this;
        //   return (video.currentTime / video.duration) * 100;
        // };
        this.getTimerValue = function () {
            var _a = _this, video = _a.video, formatTime = _a.formatTime;
            var currentTime = formatTime(video.currentTime);
            var duration = formatTime(video.duration);
            if (video.duration === Infinity)
                return "" + currentTime;
            return currentTime + " / " + duration;
        };
        this.getCurrentTime = function () {
            var _a = _this, video = _a.video, formatTime = _a.formatTime;
            return formatTime(video.currentTime);
        };
        this.formatTime = function (time) {
            // eslint-disable-next-line no-bitwise
            var hrs = ~~(time / 3600);
            // eslint-disable-next-line no-bitwise
            var mins = ~~((time % 3600) / 60);
            // eslint-disable-next-line no-bitwise
            var secs = ~~time % 60;
            var ret = "";
            if (hrs > 0) {
                ret += hrs + ":" + (mins < 10 ? "0" : "");
            }
            ret += mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        };
        this.preventFullscreen = function (e) { return e.stopPropagation(); };
        // TODO: check this on both controllers  and on staging
        this.handleReplayClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var video;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        video = this.video;
                        video.currentTime = 0;
                        return [4 /*yield*/, video.play()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.isFullscreenModeActive = function () { return !!document.fullscreenElement; };
        this.handleFullscreenMode = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, videoContainer, isFullscreenModeActive, videoPlayer;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, videoContainer = _a.videoContainer, isFullscreenModeActive = _a.isFullscreenModeActive;
                        videoPlayer = document.querySelector("#sendspark-video-player");
                        if (!!isFullscreenModeActive()) return [3 /*break*/, 4];
                        if (!!!videoContainer.requestFullscreen) return [3 /*break*/, 2];
                        return [4 /*yield*/, videoContainer.requestFullscreen()];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        videoPlayer === null || videoPlayer === void 0 ? void 0 : videoPlayer.webkitEnterFullscreen();
                        _b.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, document.exitFullscreen()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        this.handleProgressBarClick = function (event, playingSecondVideo) {
            if (playingSecondVideo === void 0) { playingSecondVideo = false; }
            var _a = _this, video = _a.video, progressBar = _a.progressBar;
            var progressBarCustomIntro = document.getElementById(VideoPlayerIds_1.default.ProgressBarCustomIntro);
            var offset = progressBar.offsetWidth;
            var offsetSecondVideo = progressBarCustomIntro === null || progressBarCustomIntro === void 0 ? void 0 : progressBarCustomIntro.offsetWidth;
            var xoffset = event.nativeEvent.offsetX;
            var tryToSetTime = function () {
                // Wait for the video to load so we can get the video duration
                var id = setTimeout(function () {
                    if (isFinite(_this.video.duration)) {
                        var time = (xoffset / (playingSecondVideo ? offsetSecondVideo : offset)) *
                            _this.video.duration;
                        video.currentTime = time;
                    }
                    else {
                        tryToSetTime();
                    }
                    clearTimeout(id);
                }, 100);
            };
            tryToSetTime();
        };
        this.handleProgressBarMouseMove = function (event) {
            return _this.isMouseDownInProgressBar && _this.handleProgressBarClick(event);
        };
        this.handleProgressBarMouseDown = function () {
            return (_this.isMouseDownInProgressBar = true);
        };
        this.handleProgressBarMouseUp = function () {
            return (_this.isMouseDownInProgressBar = false);
        };
        this.handleSendsparkLogoClick = function () {
            return window.open("https://www.sendspark.com/", "_blank");
        };
        this.handleFoward = function () { };
        this.handleRewind = function () { };
        this.handleInputVolumeRangeChange = function () {
            var _a = _this, inputVolumeRange = _a.inputVolumeRange, video = _a.video;
            var volume = Number(inputVolumeRange.value) / 100;
            video.volume = volume;
        };
        this.getVolumeLevel = function () { return _this.video.volume * 100; };
        this.handleButtonVolumeClick = function () {
            var _a = _this, video = _a.video, inputVolumeRange = _a.inputVolumeRange, handleInputVolumeRangeChange = _a.handleInputVolumeRangeChange;
            if (video.volume) {
                _this.unmuteVolumeValue = inputVolumeRange.value;
                inputVolumeRange.value = "0";
                handleInputVolumeRangeChange();
            }
            else {
                inputVolumeRange.value = _this.unmuteVolumeValue;
                handleInputVolumeRangeChange();
            }
        };
        this.getPlaybackRateValue = function () {
            var _a = _this, video = _a.video, playbackRateValues = _a.playbackRateValues;
            var firstPlaybackRateValue = playbackRateValues[0];
            var actualPlaybackRateValueIndex = playbackRateValues.indexOf(video.playbackRate);
            var nextPlaybackRateValueIndex = actualPlaybackRateValueIndex + 1;
            var lastPlaybackRateValueIndex = playbackRateValues.length - 1;
            if (actualPlaybackRateValueIndex < lastPlaybackRateValueIndex) {
                var playbackRateValue = playbackRateValues[nextPlaybackRateValueIndex];
                return playbackRateValue;
            }
            return firstPlaybackRateValue;
        };
        this.progressBar = progressBar;
        this.progressBarCustomIntro = progressBarCustomIntro;
        this.video = video;
        this.buttonPlay = buttonPlay;
        this.buttonFullscreen = buttonFullscreen;
        this.buttonVolume = buttonVolume;
        this.buttonNextVideo = buttonNextVideo;
        this.inputVolumeRange = inputVolumeRange;
        this.videoContainer = videoContainer;
        this.isMouseDownInProgressBar = false;
        this.unmuteVolumeValue = inputVolumeRange.value;
    }
    return VideoPreviewController;
}());
exports.default = VideoPreviewController;
